import type {HomepageAiFeaturesModalProps} from '@Modals/homepage-ai-features-modal';
import {openHomepageAiFeaturesModal} from '@Modals/homepage-ai-features-modal';
import type {HomepageStartCreatingModalProps} from '@Modals/homepage-start-creating-modal';
import {openHomepageStartCreatingModal} from '@Modals/homepage-start-creating-modal';
import type {HomepageCreatePopupModalProps} from '@Modals/homepage-create-options-modal';
import {openCreateOptionsModal} from '@Modals/homepage-create-options-modal';
import type {AuthenticateModalProps} from '@Modals/authenticate-modal/authenticate-modal';
import {openAuthenticateModal} from '@Modals/authenticate-modal/authenticate-modal-library';

/**
 * @author Moeed Ahmad <moeed@250mils.com>
 *
 */
window.PMW.mergePMW(PMW, {
  openHomepageAiFeaturesModal(options: HomepageAiFeaturesModalProps) {
    openHomepageAiFeaturesModal(options);
  },

  openHomepageStartCreatingModal(options: HomepageStartCreatingModalProps) {
    openHomepageStartCreatingModal(options);
  },

  openHomepageCreateOptionsModal(options: HomepageCreatePopupModalProps) {
    options.includeHeader = true;
    openCreateOptionsModal(options);
  },

  openAuthenticateModal(options: AuthenticateModalProps) {
    openAuthenticateModal(options);
  },
});
